import React, { Component } from 'react'
import {getData2} from '../Api/Config';
import CirclePreloader from '../layouts/CirclePreloader';
import M from  'materialize-css/dist/js/materialize.min.js';
import 'materialize-css/dist/css/materialize.min.css';
import { Link } from 'react-router-dom';

export class History extends Component {
   state={
    notifications:null,
    isLoading:false,
    totalNotification:0,
    currentIndex:10,
    pages:[],
    currentPage:0
   }
    componentDidMount(){
       
        this.setState({isLoading:true})
        getData2('https://api.nirmallabs.com/api/v1/fcm/notification/history?size=0').then(res=>{
            if(res.notificationHistory){
                if(res.notificationHistory.content && res.notificationHistory.totalElements){
                    
                    let pages=[];
                    for (let i = 0; i <res.notificationHistory.totalElements/10; i++) {
                        pages.push(i);
                    }
                    this.setState({pages:pages});
                    this.setState({totalNotification:res.notificationHistory.content.length});

                }
            }
        })
        this.MaxLimitTo(0,10);
    }

    // LoadMore=()=>{
    //     let {totalNotification,currentIndex} = this.state;
    //     if(currentIndex<totalNotification.length){
    //         currentIndex+=3;
    //         this.setState({currentIndex});
    //         this.MaxLimitTo(currentIndex);
    //     }
    // }
    
    MaxLimitTo=(pageNum=1,size=10)=>{
        this.setState({isLoading:true});
        this.setState({currentPage:pageNum});
        getData2(`https://api.nirmallabs.com/api/v1/fcm/notification/history?page=${pageNum}&size=${size}`).then(res=>{
        
            if(res.notificationHistory){
                if(res.notificationHistory.content){
                
                    this.setState({notifications:res.notificationHistory.content})
                    this.setState({isLoading:false})
                }
            }
        })
    }

 

    callToolTips(){
        var elems = document.querySelectorAll('.tooltipped');
        M.Tooltip.init(elems, {});
    }

    render() {
        let mystyle = this.state.isLoading?{
            visibility: 'hidden'
            }:{
              visibility: 'visible',
              overflowX:'auto'
            }
        let {pages,currentPage} = this.state;
        let mystyle2 = currentPage>0?{
            visibility: 'visible'
        }:{visibility: 'hidden'};
        
        let mystyle3 = currentPage>=pages.length-1 ?{
            visibility: 'hidden'
        }:{visibility: 'visible'};   
        
        return (
            <div>
              <h5>Notifications</h5>
             
            <div className="card z-depth-2 hoverable">
                  <div className="card-content">
                  {this.state.isLoading?<CirclePreloader/>:null}
             
                <table className="highlight" style={mystyle}>
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Date</th>
                        <th className="turncate">Campaign</th>
                        <th className="turncate">Notifications</th>
                        <th colSpan='2'>Action</th>
                    </tr>
                    </thead>
                    <tbody>
                        {this.state.notifications && this.state.notifications.map(data=>{
                            this.callToolTips();
                            return (
                                <tr key={data.id}>
                                    <td>{data.id}</td>
                                    <td>{data.date}</td>
                                    <td>{data.historyDataDto.campaignName?data.historyDataDto.campaignName:'---------'}</td>
                                    <td>{data.historyDataDto.title?(<p><strong>{data.historyDataDto.title}</strong><br/>{data.historyDataDto.body}</p>):(<p>{data.historyDataDto.imageURL}</p>)}</td>
                                    <td></td>
                                    <td><Link to={{pathname:`/admin/CreateNotification/${data.id}/`,state:data.historyDataDto}} className="btn-floating btn-medium waves-effect waves-light blue" title="send again"><i className="material-icons">send</i></Link></td>
                                    {/* <td><button className="btn-floating btn-medium waves-effect waves-light red" title="delete"><i className="material-icons">delete</i></button></td> */}
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
                <br/>
                
                
                </div>
                
                </div>
                {/* {currentIndex<totalNotification.length?(<button className="btn btn-small light-blue darken-1" onClick={this.LoadMore} style={{margin:'auto',display:'block'}}>show more..</button>):null} */}
                <ul className="pagination center">
                    <li style={mystyle2} className="waves-effect"><a href="#!" onClick={()=>this.MaxLimitTo(currentPage-1,10)}><i className="material-icons">chevron_left</i></a></li>
                    {
                        pages.length && pages.map(pageNum=>{
                           return <li className={currentPage===pageNum?'active':'waves-effect'} key={pageNum} onClick={()=>this.MaxLimitTo(pageNum,10)}><a href="#!">{pageNum}</a></li>
                        })
                    }
                    <li className="waves-effect" style={mystyle3} ><a href="#!" onClick={()=>this.MaxLimitTo(currentPage+1,10)}><i className="material-icons">chevron_right</i></a></li>
                </ul>
            </div>
        )
    }
}

export default History
